import { createIcon } from "@chakra-ui/react";

export const ReportsIcon = createIcon({
  displayName: "ReportsIcon",
  viewBox: "1 1 18 14",
  path: (
    <path d="M1 7H19M1 11H19M6 6.792V15M10 6.792V15M14 6.792V15M2 15H18C18.2652 15 18.5196 14.8946 18.7071 14.7071C18.8946 14.5196 19 14.2652 19 14V2C19 1.73478 18.8946 1.48043 18.7071 1.29289C18.5196 1.10536 18.2652 1 18 1H2C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8946 1.73478 15 2 15Z" stroke="currentColor"/>
  ),
});
